import type { Degree, Radian } from "#public"

import { PI } from "./Math"

/**
 * Converts degrees to radians
 * @pure
 */
export const ToRadians = (degrees: Degree): Radian => (degrees * (PI / 180)) as Radian
